import { hashKey, QueryClient } from '@tanstack/react-query'

/**
 * Comercio (tienda) de la sesión activa. Se antepone al hash de todas las queries
 * para que dos comercios nunca compartan una entrada de caché, aunque usen la misma
 * clave (ej. misma sucursal `0`). Lo asigna el AuthProvider en INIT / LOGIN / refreshUser.
 */
let tiendaQueryScope = ''

/** Asigna el comercio que delimita la caché de React Query. `''` sin sesión. */
export const setTiendaQueryScope = (tienda: string | null | undefined) => {
  tiendaQueryScope = tienda ?? ''
}

/**
 * Cliente único de React Query de la aplicación.
 * Lo usa `QueryClientProvider` en main.tsx y las utilidades que trabajan fuera de React
 * (ej. `invalidateQuery`), para que todos compartan la misma caché.
 * Dentro de componentes y hooks se puede seguir usando `useQueryClient()`.
 *
 * `queryKeyHashFn` solo cambia la identidad de la caché: las claves visibles, la
 * invalidación por prefijo, getQueryData y setQueryData siguen funcionando igual.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      queryKeyHashFn: (queryKey) => hashKey([tiendaQueryScope, ...queryKey]),
    },
  },
})
